import styled from 'styled-components';

interface ScWheelProps {
  mainRadialGradient: string;
  spinBtnBg?: string;
  isLongOffer?: boolean;
}

export const ScWheel = styled.div<ScWheelProps>`
  perspective: 1000px;
  font-weight: 700;
  margin-top: 6rem;

  @media (max-width: 660px) {
    margin-top: 4.5rem;
  }

  & .wheel__outside {
    position: relative;
    z-index: 100;
    border-radius: 50%;
    width: 510px;
    height: 510px;
    transition: transform 0.8s;
    transform-style: preserve-3d;

    & .wheel__side {
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: -1;

      & h1 {
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
        margin: 0;
        max-width: 310px;
        color: #821f00;
        font-size: 28px;
      }

      &.left {
        left: -50%;

        & h1 {
          left: 62%;
        }
      }

      &.right {
        left: 155%;

        & h1 {
          left: 38%;
        }
      }
    }

    &.rotate {
      transform: rotateY(181deg);
    }

    & .wheel__back,
    & .wheel__front {
      position: absolute;
      width: 100%;
      height: 100%;
      backface-visibility: hidden;
      perspective: 0;
      -webkit-backface-visibility: hidden;
      transform: translate3d(0, 0, 0);

      &::after {
        content: '';
        background-image: linear-gradient(
          103.12deg,
          #c17812 5.72%,
          #f4c134 39.03%,
          #c17812 92.05%
        );
        border-radius: 50%;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 500px;
        height: 500px;
        background-origin: border-box;
        display: block;
        box-shadow: 0 0 0 5px #a34a00;
      }
    }

    & .wheel__front {
      & .wheel__circle_0 {
        animation: 1.2s ease-in-out 0s infinite alternate none running
          circleBase;
      }

      & .wheel__circle_1 {
        animation: circleFirstSpin 7s cubic-bezier(0.4, 0.4, 0, 1) forwards;
      }

      & .wheel__circle_2 {
        transform: rotate(2116deg);
        animation: circleSecondSpin 7s cubic-bezier(0.6, 0.2, 0, 1) forwards;
        animation-delay: 2s;
      }

      & .wheel__darken {
        position: absolute;
        width: 100%;
        height: 100%;
        padding: 13px;
        opacity: 0.9;
        z-index: 11;
      }
    }

    & .wheel__back {
      transform: rotateY(180deg);
    }

    & .wheel__pointer {
      position: absolute;
      top: 20%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 9999;

      &.back {
        z-index: -1;
      }
    }
    & .wheel__img-wrapper,
    & .wheel__center {
      display: flex;
      justify-content: center;
      align-items: center;
      aspect-ratio: 1/1;
      background-origin: border-box;
    }

    & .wheel__img-wrapper {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      z-index: 1000;

      & > p {
        position: absolute;
        top: 29%;
        left: 50%;
        transform: translate(-50%, -50%);
        text-transform: uppercase;
        font-size: 1.75rem;
      }

      & .content {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 10;
        text-transform: uppercase;
        animation: 1.2s ease-in-out 0s infinite alternate none running
          circleBase;

        &.spin-1 {
          animation: circleFirstSpin 7s cubic-bezier(0.4, 0.4, 0, 1) forwards;
        }

        &.spin-2 {
          transform: rotate(2116deg);
          animation: circleSecondSpin 7s cubic-bezier(0.6, 0.2, 0, 1) forwards;
          animation-delay: 2s;
        }

        & .short {
          font-size: 16px;
          line-height: 0px;
        }

        & p {
          width: min-content;
          font-size: 38px;
          position: absolute;
          transform: translate(-50%, -50%);
          text-align: center;
          line-height: 24px;

          & span {
            font-size: ${({ isLongOffer }) => (isLongOffer ? '17px' : '20px')};
            line-height: 0px;
          }

          &.de {
            font-size: 27px;
          }

          &[class^='fr-'],
          &.fr {
            font-size: 27px;

            & > span {
              font-size: 17px;
            }
          }

          &:nth-child(1) {
            top: 20%;
            left: 50%;
          }
          &:nth-child(2) {
            top: 27.5%;
            left: 72.5%;
            transform: translate(-50%, -50%) rotate(45deg);
          }
          &:nth-child(3) {
            top: 50%;
            left: 80%;
            transform: translate(-50%, -50%) rotate(90deg);
          }
          &:nth-child(4) {
            top: 72%;
            left: 72%;
            transform: translate(-50%, -50%) rotate(135deg);
          }
          &:nth-child(5) {
            top: 80%;
            left: 50%;
            transform: translate(-50%, -50%) rotate(180deg);
          }
          &:nth-child(6) {
            top: 72%;
            left: 27%;
            transform: translate(-50%, -50%) rotate(225deg);
          }
          &:nth-child(7) {
            top: 50%;
            left: 20%;
            transform: translate(-50%, -50%) rotate(270deg);
          }
          &:nth-child(8) {
            top: 27.5%;
            left: 27.5%;
            transform: translate(-50%, -50%) rotate(315deg);
          }
        }
      }
    }

    & .wheel__center {
      background-image: linear-gradient(
        103.12deg,
        #c17812 5.72%,
        #f4c134 39.03%,
        #c17812 92.05%
      );
      border-radius: 50%;
      width: 114px;
      position: absolute;
      z-index: 99999;

      & .wheel__btn {
        background: linear-gradient(171.74deg, #ffeb7d 11.44%, #bf610f 99.56%);
        font-size: 32px;
        line-height: 38px;
        color: #821f00;
        padding: 5px 10px;
        min-width: 156px;
        flex: 0 0 auto;
        border-radius: 40px;
        white-space: nowrap;
        z-index: 2;
        text-transform: uppercase;
        font-weight: 700;
        cursor: pointer;
        box-shadow: 0px 0px 32px #8c4300;
        transition: box-shadow 0.3s;
        user-select: none;

        &:hover {
          box-shadow: 0px 0px 18px 5px rgb(244 193 52 / 32%);
        }
      }

      &::after {
        content: '';
        width: 96px;
        aspect-ratio: 1/1;
        background: ${({ mainRadialGradient, spinBtnBg }) =>
          spinBtnBg ? spinBtnBg : mainRadialGradient};
        border-radius: 50%;
        position: absolute;
      }
    }
    @media (max-width: 1120px) {
      & .wheel__side {
        & h1 {
          font-size: 22px;
        }

        &.left {
          & h1 {
            left: 70%;
          }
        }

        &.right {
          & h1 {
            left: 30%;
          }
        }
      }
    }

    @media (max-width: 980px) {
      & .wheel__side {
        display: none;
      }
    }

    @media (max-width: 660px) {
      zoom: 0.8;
    }

    @media (max-width: 450px) {
      zoom: 0.7;
    }
  }

  @keyframes circleBase {
    0% {
      transform: rotate(2deg);
    }

    100% {
      transform: rotate(-2deg);
    }
  }

  @keyframes circleFirstSpin {
    0% {
      transform: rotate(0deg);
      -webkit-transform: rotate(0deg);
    }

    100% {
      transform: rotate(2115deg);
      -webkit-transform: rotate(2115deg);
    }
  }

  @keyframes circleSecondSpin {
    0% {
      transform: rotate(2116deg);
    }

    100% {
      transform: rotate(4590deg);
    }
  }
`;
